import React, { useEffect } from "react";
import { useHistory } from "react-router-dom"; // useHistory와 useLocation 추가
import { Typography, Stack } from "@mui/material";
import { List } from "./Styled/LanguageStyled"
import { inject, observer } from "mobx-react";
import { injectIntl } from "react-intl";
import { COMMON_UTIL } from '../../common/util/common.util';
import CommonLoading from "@/views/CommonComponent/CommonLoading";
import TitleBox from "../CommonComponent/TitleBox";
import { usePenStatus } from "../../nativebridge/PenStatus";
import { customSendSetting } from "../../nativebridge/JsToNative";
import {
  NativeToJsBridge,
  NativeToJsEventName,
} from "../../nativebridge/NativeToJs";

function AppLanguageSetting(props) {
  const history = useHistory();
  const { intl, languageStore } = props;
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  const [loading, setLoading] = React.useState(false);

  const handleBack = () => {
    history.goBack();
  };

  // let isConnectPokoro = false;

  const isConnectPokoroRef = React.useRef(false);


  const handleLanguageChange = (language) => {

    languageStore.setLanguage(language);
    const countryCode = COMMON_UTIL.getCountryCodeFromLanguage(language);

    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      deviceInfo: {
        ...prevStatus.deviceInfo, // spread the previous deviceInfo object
        lang_system: countryCode, // update lang_main
      },
    }));
    console.log(
      `==========AppLanguageSetting handleLanguageChange isConnectPokoroRef== ${isConnectPokoroRef.current},countryCode=${countryCode},languageStore.language=${languageStore.language} `
    );
    if (isConnectPokoroRef.current) {
      setLoading(true);
      const settingData = {

        messageType: "POKORO2_Settings",
        payload: {
          lang_system: countryCode,
          lang_speaking: globalPenStatus.deviceInfo.lang_speaking,
          lang_listening_main: globalPenStatus.deviceInfo.lang_listening_main,
          lang_listening_sub: globalPenStatus.deviceInfo.lang_listening_sub,
        },
      };
      customSendSetting(JSON.stringify(settingData));
    }
  };

  useEffect(() => {
    isConnectPokoroRef.current = globalPenStatus.isConnect;
    console.log(
      `==========AppLanguageSetting useEffect isConnectPokoroRef== ${isConnectPokoroRef.current},globalPenStatus.isConnect=${globalPenStatus.isConnect} `
    );
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnected,
      async (event) => {
        const jsonStr = event;
        isConnectPokoroRef.current = true;
      }
    );
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        const jsonStr = event;
        isConnectPokoroRef.current = false;
        setLoading(false);

        console.log(
          `==========AppLanguageSetting onDeviceDisConnected isConnectPokoroRef== ${isConnectPokoroRef.current}`
        );

      }
    );
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onCustomSendResult,
      async (event) => {
        const jsonStr = event;
        setLoading(false);
      }
    );
    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onCustomSendResult
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceDisConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnected
      );

    };

  }, []);

  return (
    <>
      <Stack width='100%'>
        <TitleBox
          onBack={handleBack}
          title={intl.formatMessage({ id: "language_settings" })}
          subtitle={
            <>
              <Typography variant="body2">
                {intl.formatMessage({ id: "language_settings_description" })}
              </Typography>
              <Typography
                variant="caption"
                component="p"
                sx={{ color: "#909195", fontSize: "0.75rem", mt: 0.5, m: 0 }}
              >
                {intl.formatMessage({ id: "system_voice_instruction" })}
              </Typography>
            </>
          }
        />
        <Stack pt={4}>
          <List selected={languageStore.language === 'ko'} onClick={() => handleLanguageChange("ko")}>
            <Typography variant="body1">{intl.formatMessage({ id: "KR" })}</Typography>
            <Typography variant="caption" color="#909195">한국어</Typography> 
          </List>
          <List selected={languageStore.language === 'en'} onClick={() => handleLanguageChange("en")}>
            <Typography variant="body1">{intl.formatMessage({ id: "US" })}</Typography>
            <Typography variant="caption" color="#909195">English</Typography> 
          </List>
          <List selected={languageStore.language === 'ja'} onClick={() => handleLanguageChange("ja")}>
            <Typography variant="body1">{intl.formatMessage({ id: "JP" })}</Typography>
            <Typography variant="caption" color="#909195">日本語</Typography> 
          </List>
          <List selected={languageStore.language === 'zh'} onClick={() => handleLanguageChange("zh")}>
            <Typography variant="body1">{intl.formatMessage({ id: "CN" })}</Typography>
            <Typography variant="caption" color="#909195">简体中文</Typography> 
          </List>
        </Stack>
      </Stack>
      {
        loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 9999,
            }}
          >
            <CommonLoading text={intl.formatMessage({ id: "setting_sending" })} /> {/* 설정 정보를 전송 중입니다. */}
          </div>
        )
      }
    </>
  );
}

export default injectIntl(inject('languageStore')(observer(AppLanguageSetting)));
